/**
 * Alitools Shopping Assistant
 *
 * Exposes exactly one WAR entry — `assets/fonts/*` — to `<all_urls>` with no
 * `use_dynamic_url`. Narrow, but the font files are named by family/subset/weight
 * (`OpenSans-Regular-latin-400.woff2`), not build-hashed, so a fixed probe stays valid
 * across releases.
 *
 * The extension's icons are internal (not web-accessible), so fonts are the only page-
 * reachable surface — but one is enough: the ID in the URL makes any successful fetch
 * conclusive.
 *
 * Manifest verified against version 26.6.1.18125.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'eenflijjbchafephdplkdmeenekabdfb';

export const alitools: ExtensionDefinition = {
  id: ID,
  name: 'Alitools Shopping Assistant',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 400_000,
  notes:
    'Only assets/fonts/* is web-accessible (to every origin). The font names are ' +
    'stable, so a fixed fetch remains a conclusive signal.',
  signals: [
    {
      id: 'war-opensans-latin-400',
      kind: 'web-accessible-resource',
      description:
        'Fetch assets/fonts/OpenSans-Regular-latin-400.woff2 — a stably-named bundled ' +
        'font exposed to every origin.',
      weight: 1,
      run: () => probeFetch(ID, 'assets/fonts/OpenSans-Regular-latin-400.woff2'),
    },
    {
      id: 'war-opensans-latin-700',
      kind: 'web-accessible-resource',
      description:
        'Fetch the 700-weight of the same font — a second stable path corroborating the first.',
      weight: 0.5,
      run: () => probeFetch(ID, 'assets/fonts/OpenSans-Regular-latin-700.woff2'),
    },
  ],
};
